import httpClient from '@/api/http-client';

const endpoint = 'api/impeccable-reputation-checks';

const impeccableReputationChecksService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  update: (reputationCheck) =>
    httpClient.put(`${endpoint}/${reputationCheck.id}/change-status`, reputationCheck),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  getPdfForm: (payload) =>
    httpClient({
      url: `${endpoint}/${payload.id}/pdf-form`,
      method: 'GET',
      responseType: 'blob',
      params: payload,
    }),

  getMultiplePdfForm: (params) =>
    httpClient({
      url: `${endpoint}-multiple-pdf-form`,
      method: 'GET',
      responseType: 'blob',
      params,
    }),

  updateStatus: (payload) =>
    httpClient.patch(`${endpoint}/${payload.background_check_id}/status`, payload),

  updateMultipleStatuses: (payload) => httpClient.patch(`${endpoint}/change-status`, payload),

  getRejectedPermits: (params) =>
    httpClient.get('api/permits-rejected-because-of-reputation', { params }),
};

export default impeccableReputationChecksService;
